module.exports = __webpack_public_path__ + "img/id.3cfb87d6.png";